import { render } from "./GestionHuellas.vue?vue&type=template&id=48608942&scoped=true"
import script from "./GestionHuellas.vue?vue&type=script&lang=js"
export * from "./GestionHuellas.vue?vue&type=script&lang=js"

import "./GestionHuellas.vue?vue&type=style&index=0&id=48608942&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48608942"]])

export default __exports__